import { postData } from "../api/ApiRest";

///Función para capturar los diferentes tipos de estados al momento de realizar un proceso:
///Actualizar, Crear, Eliminar
///Diego F Sandoval F
///20-08-2025
function auditoriaSet(valorInicial = {}, valorFinal = {}, tipo, modulo, id = null, seccion) {
    if (tipo === 'A') ///La letra A indica actualizar
        auditoriaActualizar(valorInicial, valorFinal, modulo, id, seccion);
    else if (tipo === 'C')///La letra C indica creación
        auditoriaCrear(valorInicial, modulo, id, seccion);
    else if (tipo === 'E') ///La letra E indica eliminación
        auditoriaEliminar(valorInicial, modulo, id, seccion);
}

////Función para guardar auditoria cuando es un edit o una actualización
///Diego F Sandoval F
///20-08-2025
function auditoriaActualizar(valorInicial, valorFinal, modulo, id, seccion) {
    ///Comparamos el valor inicial contra el valor final para valdiar si hay cambios y poder realizar la modificación correspondiente
    if (JSON.stringify(valorInicial) !== JSON.stringify(valorFinal)) {
        const diff = {}; ///Variable que me permitira guardar las diferencias entre json

        ///Ciclo que me permitira recorrer cada uno de los campos correspondientes para saber cual fue modificado
        for (const key in valorFinal) {
            if (valorFinal[key] !== valorInicial[key]) { ///Si hay diferencia en algún campo se captura automaticamente
                diff[key] = {
                    Antes: valorInicial[key],
                    Despues: valorFinal[key]
                };
            }
        }

        ///Convertimoa el json en un texto
        const objectJson = JSON.stringify(diff);

        ///Enviamos la info al api para crear el registro correspondiente
        postData('api/Usuario/setAuditoria', { tipo: 'Modifica', modulo: modulo, id: id, seccion: seccion }, objectJson, false).then(response => {

        }, error => {
            console.log(error);
        })
    }
}

///Función para crear la auditoria de registros nuevos
///Diego F Sandoval F
///20-08-2025
function auditoriaCrear(valorInicial, modulo, id, seccion) {
    const objectJson = JSON.stringify(valorInicial);

    postData('api/Usuario/setAuditoria', { tipo: 'Crea', modulo: modulo, id: id, seccion: seccion }, objectJson, false);
}

///Función para guardar la auditoria cuando eliminan un registro de algún proceso en TAE
///Diego F Sandoval F
///20-08-2025
function auditoriaEliminar(valorInicial, modulo, id, seccion) {
    const objectJson = JSON.stringify(valorInicial);

    postData('api/Usuario/setAuditoria', { tipo: 'Elimina', modulo: modulo, id: id, seccion: seccion }, objectJson, false);
}


export default auditoriaSet;